<template>
  <div v-if="profile" class="starter-page">
    <div
      class="navbar-dark project-header pt-2 pb-0 px-4 d-flex justify-content-end teestt"
    >
      <div class="gantt-title-wrapper ">
        <a @click="$router.back()" style="cursor: pointer;" v-if="false">
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a>

        <small
          class="align-middle d-inline-block ticket-title__client-name px-3 text-primary"
          v-if="profile"
          >{{ profile.first_name }} {{ profile.last_name }}</small
        >
        <span
          class="align-middle d-inline-flex align-items-center  p-0 text-primary"
        >
          <a
            style="cursor: pointer;"
            @click="_onPrevClicked"
            class="text-muted gPrev pr-1"
          >
            <i class="fal fa-angle-left"></i>
          </a>

          <small class="text-primary px-1">{{ formattedDate }}</small>
          <a
            style="cursor: pointer;"
            @click="_onNextClicked"
            class="text-muted gNext pl-1"
          >
            <i class="fal fa-angle-right"></i>
          </a>
        </span>
      </div>

      <div class="d-flex align-items-center pl-3">
        <!-- <div class="view-mode align-items-center d-flex">
          <a class="gantt-chart-view" :class="{'text-success': ganttView==false}" @click="ganttView=false"><i class="fas fa-th-list"></i></a>
           <a class="table-list-view" @click="ganttView=true" :class="{'text-success': ganttView}"><i class="fas fa-chart-bar"></i></a>
        </div> -->
        <button
          v-if="false"
          class="btn btn-sm text-white bg-info my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
          @click="$router.back()"
        >
          My Projects
        </button>

        <div>
          <flat-picker
            @on-open="() => {}"
            @on-close="() => {}"
            @on-change="
              () => {
                this.fetchAllRecords();
              }
            "
            :config="{ wrap: true, allowInput: false }"
            class="form-control datepicker"
            v-model="selectedDate"
          >
          </flat-picker>
          <a
            @click="_onCalendarClicked"
            class="nav-link icon-shape icon-shape--25 icon-shape--white icon-sm icn-calendar-nav p-0 timesheet-icon lh-1 d-flex align-items-center justify-content-center bg-light-grey"
            data-toggle
            data-original-title="Timesheet Entry"
            data-target="offcanvasTimer"
            data-offcanvasfrom="offcanvas"
          >
            <i class="ni ni-calendar-grid-58 icn-calendar-nav "></i>
          </a>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column justify-start">
      <transition name="slide">
        <TimeSheetGantt
          type="timesheet"
          :currentDate="selectedDate"
          :ganttView="ganttView"
          :ganttZoom="ganttZoom"
          :currency="profile.currency"
          ref="aa"
          v-if="tasks"
          :tasks="tasks"
          color-class="timesheetGantt"
          @task-link-clicked="handleTaskLinkClick"
          @dblClickEmptyArea="handleTaskDblClick"
          @task-dbl-click="handleTaskDblClick"
          @task-dragged="handleTasDrag"
        />
      </transition>
    </div>

    <portal to="sidebar" v-if="tasks && showEdit">
      <timeline-edit
        :show="showEdit"
        @outSideClicked="showEdit = false"
        :fullWidth="false"
        :timesheet="data"
        :clickedDate="selectedDate"
        @timesheetCreated="onTimesheetCreated"
        @timesheetUpdated="onTimesheetUpdated"
      />
    </portal>

    <!-- <div class="project__details" v-if="tasks && ganttView">
      <p>
        Total
        
        tasks
      </p>
    </div> -->
  </div>
</template>
<script>
import TimeSheetGantt from "@/app/components/TimeSheetGantt.vue";
import TimelineEdit from "@/app/components/TimelineEdit.vue";

import { mapMutations, mapState, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  name: "TimesheetHome",
  components: {
    TimeSheetGantt,
    flatPicker,
    TimelineEdit
  },
  data() {
    return {
      ganttView: "15_mins",
      showEdit: false,
      ganttZoom: "few",
      selectedDate: moment().format("yyyy-MM-DD"),
      tasks: null,
      data: null,
      oldTasks: {
        data: []
      }
    };
  },
  computed: {
    //...mapState("task", ["tasks"]),
    ...mapState(["ganttRender"]),
    ...mapState("user", ["profile"]),
    formattedDate() {
      return moment(this.selectedDate).format("yyyy-MM-DD");
    }
  },
  watch: {
    ganttRender(val) {
      if (val) {
        //this.fetchAllRecords();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchAllRecords();
    });
  },
  methods: {
    ...mapActions("timesheet", [
      "fetchMyTimesheetEntries",
      "updateTimesheetEntry"
    ]),

    async fetchAllRecords() {
      //alert(this.profile.id)
      try {
        let res = await this.fetchMyTimesheetEntries({
          startDate: moment(this.selectedDate).format("yyyy-MM-DD"),
          timezone: "Asia/Kathmandu"
        });
        this.tasks = res;
      } catch (error) {
        console.log(error, "Error fetching timesheet entries");
        //this.$snack.success("Could not fetch timesheet entries")
      }
    },

    _onNextClicked() {
      let curDate = moment(this.selectedDate).add(1, "day");
      this.selectedDate = curDate.format("yyyy-MM-DD");
      this.fetchAllRecords();
    },

    _onPrevClicked() {
      let curDate = moment(this.selectedDate).subtract(1, "day");
      this.selectedDate = curDate.format("yyyy-MM-DD");
      this.fetchAllRecords();
    },

    handleDblClick() {
      //alert("dblClick")
    },

    _onCalendarClicked() {
      //this.$emit('calendarClicked')
    },

    onTimesheetCreated() {
      this.fetchAllRecords();
    },
    onTimesheetUpdated() {
      this.fetchAllRecords();
    },

    handleTaskDblClick(id, event, task) {
      //alert(id+"sss")
      //this.$emit("taskDblClick", id, event);
      console.log(id, task);
      this.showEdit = true;

      if (id) {
        this.data = task;
      } else {
        this.data = null;
      }
    },

    handleTasDrag(id, mode, e) {
      this._onTaskDragged(mode);
    },

    async _onTaskDragged(mode) {
      let task = mode.task;

      //return
      if (task) {
        let t = { ...task };
        t.start_date = moment(mode.start_date, "DD-MM-yyyy hh:mm:ss")
          .utc()
          .format("yyyy-MM-DD HH:mm:ss");
        t.end_date = moment(mode.end_date, "DD-MM-yyyy hh:mm:ss")
          .utc()
          .format("yyyy-MM-DD HH:mm:ss");
        t.timesheet_id = mode.id;
        try {
          let res = await this.updateTimesheetEntry(t);
          await this.fetchAllRecords();
        } catch (error) {
          console.log("Update timesheet error");
        }
      }
    },

    onEmptyAreaDblClicked() {},

    handleTaskLinkClick(id) {
      //alert("link",id)
      //this.$router.push("/projects/" + id + "/tasks/" + id);
      // this.$emit(
      //   "taskDblClick",
      //   {
      //     id: 20,
      //     project_id: 16,
      //     name: 'Sagar',
      //   },
      //   event
      // );
    }
  }
};
</script>
<style>
.flatpickr-input {
  height: 0;
  width: 0;
  opacity: 0 !important;
  position: absolute;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

/* .flatpickr-calendar {
  background-color: green;
} */

.flatpickr-calendar {
  font-size: 0.74rem;
  box-shadow: 0px 0px 38px rgba(0, 0, 0, 0.36);
  border: none;
  border-radius: 8px;
}

.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  line-height: 1;
  padding: 5px 10px;
  display: flex;
  align-items: center;
}

.flatpickr-current-month {
  padding: 0;

  display: flex;

  align-items: center;
  /* background: greenyellow; */
  justify-content: space-between;
}

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(94, 101, 129, 0.3);
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  font-size: 0.8rem;
  font-weight: 500;
  color: #5e6581;
  padding-left: 0;
  text-align: center;
  padding-right: 15px;
}

.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: transparent;
}

.flatpickr-current-month .numInputWrapper {
  margin-left: 1rem;
}

.flatpickr-calendar .flatpickr-weekday {
  font-size: 0.6rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: #18234d;
}

.flatpickr-weekdays {
  background: #f0f1f6;
}

.flatpickr-day {
  line-height: 36px;
  color: #5e6581;
}

.flatpickr-calendar .flatpickr-current-month span.cur-month,
.flatpickr-calendar .flatpickr-current-month input.cur-year {
  color: #5e6581;
  font-size: 0.8rem;
}

.flatpickr-calendar .flatpickr-current-month span.cur-month:hover,
.flatpickr-calendar .flatpickr-current-month input.cur-year:hover {
  background: white;
  border-radius: 0px;
}

.flatpickr-calendar .flatpickr-day.selected:hover,
.flatpickr-calendar .flatpickr-day.selected,
.flatpickr-calendar .flatpickr-day:hover {
  background: #fee400;
  color: #18234d;
}

.flatpickr-calendar .flatpickr-day.today {
  border: 1px solid #fee400;
  font-weight: 600;
}

.numInputWrapper span {
  padding: 0 4px 0 5px;
  border: none;
}

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 10px;
  height: 10px;
  fill: #8c91ac;
}

.flatpickr-calendar .flatpickr-current-month span.cur-month,
.flatpickr-calendar .flatpickr-current-month input.cur-year {
  padding-left: 0px;
}
.flatpickr-months {
  border-bottom: 1px #e5e7ef solid;
}
</style>
